function getCurrentSelectedProduct() {

  const checked = document.querySelector(
    'input[name="subscription_option"]:checked'
  );

  if (!checked) return null;

  try {
    return JSON.parse(checked.dataset.product || "{}");
  } catch (e) {
    console.warn("Invalid product JSON");
    return null;
  }
}


// =========================================
// RECALC SUBSCRIPTION PRICES
// =========================================
function recalcSubscriptionPrices() {

  const currencySymbol =
    document.getElementById('shop-money-format')?.dataset.currency || '$';

  const fmt = cents =>
    currencySymbol + (cents / 100).toFixed(2);

  const checkedRadio = document.querySelector(
    'input[name="subscription_option"]:checked'
  );

  if (!checkedRadio) return;

  document
    .querySelectorAll('input[name="subscription_option"]')
    .forEach(radio => {

      const block = radio.closest(
        '.custom-product-detail__subscription-block'
      );

      if (!block) return;

      const radioProduct = JSON.parse(
        radio.dataset.product || '{}'
      );

      let totalPriceCents = 0;

      document
        .querySelectorAll('.bundle-item')
        .forEach(item => {

          const age =
            item.querySelector('.age-select')?.value;

          const weight =
            item.querySelector('.weight-select')?.value;

          if (!age || !weight) return;

          const variant = radioProduct.variants?.find(v => {
            return (
              String(v.option1).trim() === String(age).trim() &&
              String(v.option2).trim() === String(weight).trim()
            );
          });

          if (variant?.price) {
            totalPriceCents += Number(variant.price);
          }
        });

      const discountPct = parseFloat(
        radio.getAttribute('data-input') || '0'
      );

      const months = parseFloat(
        radio.getAttribute('data-month-value') || '1'
      );

      const discountAmount = Math.round(
        totalPriceCents * discountPct / 100
      );

      const finalCents =
        totalPriceCents - discountAmount;

      const perMonthCents =
        Math.round(finalCents / months);

      const comparePerMonth =
        Math.round(totalPriceCents / months);

      // billed
      const billedEl =
        block.querySelector('.billed-price');

      if (billedEl) {
        billedEl.setAttribute('data-original-pirce', fmt(finalCents));
        billedEl.textContent = fmt(finalCents);
      }

      // final monthly
      const perMonthEl =
        block.querySelector('.subscription-final-price');

      if (perMonthEl) {
        perMonthEl.setAttribute('data-permonth-final-price', fmt(perMonthCents));
        perMonthEl.textContent = fmt(perMonthCents);
      }

      // compare monthly
      if (discountPct > 0) {

        const compareEl =
          block.querySelector('.subscription-compare-price');

        if (compareEl) {

          compareEl.setAttribute(
            'data-com-price',
            fmt(comparePerMonth) + ' /mon'
          );

          const textNode =
            [...compareEl.childNodes]
            .find(n => n.nodeType === Node.TEXT_NODE);

          if (textNode) {
            textNode.textContent = fmt(comparePerMonth) + ' ';
          }
        }
      }
    });

  updateBtnPrice();
}


// =========================================
// BUTTON PRICE
// =========================================
function updateBtnPrice() {

  const checked = document.querySelector(
    'input[name="subscription_option"]:checked'
  );

  if (!checked) return;

  const block = checked.closest(
    '.custom-product-detail__subscription-block'
  );

  if (!block) return;

  const priceEl = block.querySelector('.billed-price');

  if (!priceEl) return;

  const btnPrice = document.querySelector('.btn-prive');

  if (!btnPrice) return;

  btnPrice.textContent = '- ' + priceEl.textContent.trim();
}


// =========================================
// VARIANT BUNDLE
// =========================================
document
  .querySelectorAll(".variant-bundle")
  .forEach(wrapper => {

    const container =
      wrapper.querySelector(".bundle-container");

    const addBtn =
      wrapper.querySelector(".add-btn");

    if (!container || !addBtn) return;


    const getMaxVariants = () => {
      const currentProduct = getCurrentSelectedProduct();
      return currentProduct?.variants?.length || 0;
    };

    const getTotalPriceCents = () => {

      let total = 0;

      container.querySelectorAll(".variant-id").forEach(input => {
        const price = parseInt(input.dataset.varinatPice || "0", 10);
        if (!isNaN(price) && price > 0) total += price;
      });

      return total;
    };

    const getVariant = (age, weight) => {

      const currentProduct = getCurrentSelectedProduct();

      if (!currentProduct || !currentProduct.variants) return null;

      return currentProduct.variants.find(variant => {
        const option1 = String(variant.option1 || "").trim();
        const option2 = String(variant.option2 || "").trim();
        return (
          option1 === String(age).trim() &&
          option2 === String(weight).trim()
        );
      }) || null;
    };

    const updateAddButton = () => {

      const count = container.querySelectorAll(".bundle-item").length;
      const disabled = count >= getMaxVariants();

      addBtn.disabled = disabled;
      addBtn.style.opacity = disabled ? ".7" : "1";
      addBtn.style.cursor = disabled ? "not-allowed" : "pointer";
    };

    const updateRemoveButtons = () => {

      const items = container.querySelectorAll(".bundle-item");

      items.forEach(item => {
        const removeBtn = item.querySelector(".remove-btn");
        if (!removeBtn) return;
        removeBtn.style.display = items.length === 1 ? "none" : "block";
      });
    };

    const updateInputIndexes = () => {

      const items = container.querySelectorAll(".bundle-item");

      items.forEach((item, index) => {
        const input = item.querySelector(".variant-id");
        if (!input) return;
        input.name = `items[${index}][id]`;
      });
    };

    const resolveVariantOnly = (item) => {

      if (!item) return;

      const ageEl = item.querySelector(".age-select");
      const weightEl = item.querySelector(".weight-select");
      const input = item.querySelector(".variant-id");

      if (!ageEl || !weightEl || !input) return;

      const age = ageEl.value;
      const weight = weightEl.value;

      if (!age || !weight) {
        input.value = "";
        input.dataset.varinatPice = "";
        return;
      }

      const variant = getVariant(age, weight);

      if (!variant) {
        input.value = "";
        input.dataset.varinatPice = "";
        return;
      }

      input.value = String(variant.id);
      input.dataset.varinatPice = variant.price != null ? String(variant.price) : "";

      const priceEl = item.querySelector("[data-price]");
      if (priceEl) {
        priceEl.textContent = (Number(variant.price || 0) / 100).toFixed(2);
      }
    };

    const updateVariant = (item) => {

      if (!item) return;

      const ageEl = item.querySelector(".age-select");
      const weightEl = item.querySelector(".weight-select");
      const input = item.querySelector(".variant-id");

      if (!ageEl || !weightEl || !input) return;

      const age = ageEl.value;
      const weight = weightEl.value;

      if (!age || !weight) {
        input.value = "";
        input.dataset.varinatPice = "";
        recalcSubscriptionPrices();
        updateOneTimeVariantStorage();
        return;
      }

      const variant = getVariant(age, weight);

      if (!variant) {
        input.value = "";
        input.dataset.varinatPice = "";
        recalcSubscriptionPrices();
        updateOneTimeVariantStorage();
        return;
      }

      input.value = String(variant.id);
      input.dataset.varinatPice = variant.price != null ? String(variant.price) : "";

      const priceEl = item.querySelector("[data-price]");
      const compareEl = item.querySelector("[data-compare-price]");

      if (priceEl) {
        priceEl.textContent = (Number(variant.price || 0) / 100).toFixed(2);
      }

      if (compareEl && variant.compare_at_price) {
        compareEl.textContent = (Number(variant.compare_at_price) / 100).toFixed(2);
      }

      recalcSubscriptionPrices();
      updateOneTimeVariantStorage();
    };

    const removeBlock = (item) => {

      if (!item) return;

      item.remove();

      updateRemoveButtons();
      updateAddButton();
      updateInputIndexes();
      recalcSubscriptionPrices();
      updateOneTimeVariantStorage();
    };

    const bind = (item) => {

      if (!item) return;

      const ageSelect = item.querySelector(".age-select");
      const weightSelect = item.querySelector(".weight-select");
      const removeBtn = item.querySelector(".remove-btn");

      if (ageSelect) {
        ageSelect.addEventListener("change", () => updateVariant(item));
      }

      if (weightSelect) {
        weightSelect.addEventListener("change", () => updateVariant(item));
      }

      if (removeBtn) {
        removeBtn.addEventListener("click", () => removeBlock(item));
      }
    };

    const createBlock = () => {

      const firstItem = container.querySelector(".bundle-item");
      if (!firstItem) return null;

      const clone = firstItem.cloneNode(true);

      const ageEl = clone.querySelector(".age-select");
      const weightEl = clone.querySelector(".weight-select");
      const input = clone.querySelector(".variant-id");

      if (ageEl) {
        ageEl.selectedIndex = 0;
        ageEl.value = ageEl.options[0]?.value ?? "";
      }

      if (weightEl) {
        weightEl.selectedIndex = 0;
        weightEl.value = weightEl.options[0]?.value ?? "";
      }

      if (input) {
        input.value = "";
        input.dataset.varinatPice = "";
        input.dataset.comparePrice = "";
      }

      const priceEl = clone.querySelector("[data-price]");
      const compareEl = clone.querySelector("[data-compare-price]");

      if (priceEl) priceEl.textContent = "";
      if (compareEl) compareEl.textContent = "";

      bind(clone);
      resolveVariantOnly(clone);

      return clone;
    };

    addBtn.addEventListener("click", () => {

      if (addBtn.disabled) return;

      const block = createBlock();
      if (!block) return;

      container.insertBefore(block, addBtn);

      updateRemoveButtons();
      updateAddButton();
      updateInputIndexes();
      recalcSubscriptionPrices();
      updateOneTimeVariantStorage();
    });

    // INIT
    const items = container.querySelectorAll(".bundle-item");

    items.forEach(item => {
      bind(item);
      updateVariant(item);
    });

    updateRemoveButtons();
    updateAddButton();
    updateInputIndexes();
    updateBtnPrice();

    // SUBSCRIPTION CHANGE
    document.addEventListener('change', function (e) {

      if (e.target.name === 'subscription_option') {

        container.querySelectorAll('.bundle-item').forEach(item => {
          updateVariant(item);
        });

        updateAddButton();
        recalcSubscriptionPrices();
        updateOneTimeVariantStorage();
        updateBtnPrice();
      }
    });
});


document.addEventListener('DOMContentLoaded', function () {

  const sellingPlanInput =
    document.querySelector('input[name="selling_plan"]');

  const allRadios =
    document.querySelectorAll('input[name="subscription_option"]');

  function syncSellingPlan() {

    const checkedRadio = document.querySelector(
      'input[name="subscription_option"]:checked'
    );

    if (checkedRadio && sellingPlanInput) {
      sellingPlanInput.value = checkedRadio.value;
    }
  }

  syncSellingPlan();

  document.addEventListener('change', function (e) {
    if (e.target.matches('input[name="subscription_option"]')) {
      syncSellingPlan();
    }
  });
});


document.addEventListener("DOMContentLoaded", () => {



  document.querySelectorAll(".custom-button-block").forEach(block => {

  const btn = block.querySelector(".subscription-button");
  if (!btn) return;

  btn.dataset.originalText = btn.textContent.trim();

  btn.addEventListener("click", async () => {

    const selectedRadio = document.querySelector(
      'input[name="subscription_option"]:checked'
    );

    if (!selectedRadio) {
      alert("Please select a subscription option.");
      return;
    }

    const sellingPlanId = selectedRadio.dataset.sellingPlanId;

    // ✅ Resolve variants fresh from the selected product
    const currentProduct = JSON.parse(selectedRadio.dataset.product || '{}');

    const items = [];

    document.querySelectorAll('.bundle-item').forEach(item => {

      const age = item.querySelector('.age-select')?.value;
      const weight = item.querySelector('.weight-select')?.value;

      if (!age || !weight) return;

      const variant = currentProduct.variants?.find(v =>
        String(v.option1).trim() === String(age).trim() &&
        String(v.option2).trim() === String(weight).trim()
      );

      if (!variant) return;

      const cartItem = {
        id: parseInt(variant.id),
        quantity: 1
      };

      if (sellingPlanId) {
        cartItem.selling_plan = parseInt(sellingPlanId);
      }

      items.push(cartItem);
    });

    if (!items.length) {
      alert("Please select a variant.");
      return;
    }

    // ✅ Free gifts — ONLY from the selected subscription block
    // Block with gifts selected → has .cart-gift-item inside it → gifts added
    // Block without gifts → no .cart-gift-item → nothing added
    const selectedBlock = selectedRadio.closest(
      '.custom-product-detail__subscription-block'
    );

    if (selectedBlock) {
      selectedBlock.querySelectorAll('.cart-gift-item').forEach(gift => {
        const giftVariantId = gift.dataset.giftVariantId;
        if (!giftVariantId) return;
        items.push({ id: parseInt(giftVariantId), quantity: 1 }); // no selling_plan
      });
    }

    await addToCartAndOpen(btn, items);
  });
});


  // ==========================================
  // PERSONALITY BUNDLE BUTTON
  // ==========================================
  document.querySelectorAll("#cas-ad").forEach(block => {

    const btn = block.querySelector(".subscription-button-personaliity");
    if (!btn) return;

    btn.dataset.originalText = btn.textContent.trim();

    btn.addEventListener("click", async () => {

      const variantsInput = block.querySelector(".personality-variants");
      let variantIds = [];

      try {
        variantIds = JSON.parse(variantsInput?.value || "[]");
      } catch(e) {
        console.error("personality-variants parse failed:", e);
      }

      variantIds = variantIds.filter(Boolean);

      if (!variantIds.length) {
        alert("Please select your patches before adding to cart.");
        return;
      }

      const items = variantIds.map(id => ({
        id: parseInt(id),
        quantity: 1
      }));

      await addToCartAndOpen(btn, items);
    });
  });


  // ==========================================
  // ADD TO CART (SUBSCRIPTION / PERSONALITY)
  // ==========================================
  async function addToCartAndOpen(btn, items) {

    btn.disabled = true;
    btn.textContent = "Adding...";

    try {

      const addRes = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items })
      });

      if (!addRes.ok) {
        const err = await addRes.json();
        throw new Error(err.description || "Failed to add to cart");
      }

      await fetch("/cart.js", { cache: "no-store" });
      await updateCartBubble();
      await refreshCartDrawer();
      openCartDrawer();

    } catch (err) {

      console.error("Add to cart error:", err);
      alert(err.message || "Something went wrong. Please try again.");

    } finally {

      btn.disabled = false;
      btn.textContent = btn.dataset.originalText;
    }
  }


  // ==========================================
  // UPDATE CART BUBBLE
  // ==========================================
  async function updateCartBubble() {

    try {

      const res = await fetch('/?section_id=header', { cache: 'no-store' });
      const text = await res.text();
      const doc = new DOMParser().parseFromString(text, 'text/html');

      const newBubble = doc.querySelector('#cart-icon-bubble');
      const oldBubble = document.querySelector('#cart-icon-bubble');

      if (newBubble && oldBubble) {
        oldBubble.replaceWith(newBubble);
      }

    } catch (err) {
      console.error("Cart bubble update failed:", err);
    }
  }


  // ==========================================
  // REFRESH CART DRAWER
  // ==========================================
  async function refreshCartDrawer() {

    const res = await fetch("/cart?section_id=cart-drawer", {
      cache: "no-store",
      headers: { "x-requested-with": "XMLHttpRequest" }
    });

    const text = await res.text();
    const doc = new DOMParser().parseFromString(text, 'text/html');

    const newDrawer = doc.querySelector("cart-drawer");
    const oldDrawer = document.querySelector("cart-drawer");

    if (newDrawer && oldDrawer) {
      oldDrawer.replaceWith(newDrawer);
      newDrawer.dispatchEvent(new Event('cart:refresh', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
    }
  }


  // ==========================================
  // OPEN CART DRAWER
  // ==========================================
  function openCartDrawer() {

    const drawer = document.querySelector("cart-drawer");

    if (!drawer) {
      window.location.href = "/cart";
      return;
    }

    drawer.classList.add("active");

    const overlay = document.querySelector(
      '.cart-drawer-overlay, .drawer-overlay, [class*="cart-overlay"]'
    );

    if (overlay) overlay.classList.add("active");

    document.body.classList.add("overflow-hidden");
  }
});


// ==========================================
// ONE TIME PRODUCT JSON
// ==========================================
const ONETIME_PRODUCT = JSON.parse(
  document.querySelector('#onetime-product-json')?.dataset.product || '{}'
);


// ==========================================
// GET ONE TIME VARIANT
// ==========================================
function getOneTimeVariant(age, weight) {

  if (!ONETIME_PRODUCT?.variants?.length) return null;

  return ONETIME_PRODUCT.variants.find(variant => {

    const option1 = String(variant.option1 || '').trim();
    const option2 = String(variant.option2 || '').trim();

    return (
      option1 === String(age).trim() &&
      option2 === String(weight).trim()
    );

  }) || null;
}


// ==========================================
// UPDATE ONE TIME STORAGE
// ==========================================
function updateOneTimeVariantStorage() {

  document.querySelectorAll('.bundle-item').forEach(item => {

    const ageSelect = item.querySelector('.age-select');
    const weightSelect = item.querySelector('.weight-select');
    const variantInput = item.querySelector('.variant-id');

    if (!ageSelect || !weightSelect || !variantInput) return;

    const age = ageSelect.value;
    const weight = weightSelect.value;

    variantInput.dataset.onetimeVariantId = '';
    variantInput.dataset.onetimeVariantPrice = '';
    variantInput.dataset.onetimeComparePrice = '';

    if (!age || !weight) {
      const priceEl = item.querySelector('[data-price]');
      const compareEl = item.querySelector('[data-compare-price]');
      if (priceEl) priceEl.textContent = '';
      if (compareEl) compareEl.textContent = '';
      return;
    }

    const variant = getOneTimeVariant(age, weight);
    if (!variant) return;

    variantInput.dataset.onetimeVariantId = variant.id;
    variantInput.dataset.onetimeVariantPrice = variant.price || '';
    variantInput.dataset.onetimeComparePrice = variant.compare_at_price || '';

    const priceEl = item.querySelector('[data-price]');
    const compareEl = item.querySelector('[data-compare-price]');

    if (priceEl) {
      priceEl.textContent = (Number(variant.price || 0) / 100).toFixed(2);
    }

    if (compareEl && variant.compare_at_price) {
      compareEl.textContent = (Number(variant.compare_at_price || 0) / 100).toFixed(2);
    }
  });

  updateOneTimePrice();
}


// ==========================================
// ONE TIME PRICE (WITH DISCOUNT)
// ==========================================
function updateOneTimePrice() {

  const onetimePriceEl =
    document.querySelector('.onetime-priced');

  if (!onetimePriceEl) return;

  let totalCents = 0;

  document.querySelectorAll('.variant-id').forEach(input => {
    const price = parseInt(input.dataset.onetimeVariantPrice || '0', 10);
    if (!isNaN(price) && price > 0) totalCents += price;
  });

  const discountPct = parseFloat(
    onetimePriceEl.getAttribute('dis-per') || '0'
  );

  const discountAmount = Math.round(totalCents * discountPct / 100);
  const finalCents = totalCents - discountAmount;

  const currencySymbol =
    document.getElementById('shop-money-format')?.dataset.currency || '$';

  onetimePriceEl.textContent =
    currencySymbol + (finalCents / 100).toFixed(2);
}


// ==========================================
// BIND BUNDLE ITEM EVENTS
// ==========================================
function bindOneTimeEvents(item) {

  if (!item) return;

  const ageSelect = item.querySelector('.age-select');
  const weightSelect = item.querySelector('.weight-select');

  if (ageSelect) {
    ageSelect.addEventListener('change', () => updateOneTimeVariantStorage());
  }

  if (weightSelect) {
    weightSelect.addEventListener('change', () => updateOneTimeVariantStorage());
  }
}


// ==========================================
// INITIAL BIND
// ==========================================
document.querySelectorAll('.bundle-item').forEach(item => {
  bindOneTimeEvents(item);
});


// ==========================================
// OBSERVE NEW ITEMS
// ==========================================
const bundleContainer =
  document.querySelector('.bundle-container');

if (bundleContainer) {

  const observer = new MutationObserver(() => {

    document.querySelectorAll('.bundle-item').forEach(item => {

      if (item.dataset.onetimeBound) return;

      item.dataset.onetimeBound = 'true';
      bindOneTimeEvents(item);
    });

    updateOneTimeVariantStorage();
  });

  observer.observe(bundleContainer, { childList: true, subtree: true });
}


// ==========================================
// INITIAL RUN
// ==========================================
updateOneTimeVariantStorage();


// ==========================================
// ONE TIME BUTTON
// ==========================================
document.querySelectorAll('.subscription-onetime-btn').forEach(btn => {

  btn.addEventListener('click', async () => {

    // ✅ Save dis-per BEFORE textContent destroys the span
    const disPer =
      btn.querySelector('.onetime-priced')?.getAttribute('dis-per') || '0';

    const items = [];

    document.querySelectorAll('.variant-id').forEach(input => {
      const variantId = input.dataset.onetimeVariantId;
      if (!variantId) return;
      items.push({ id: parseInt(variantId), quantity: 1 });
    });

    if (!items.length) {
      alert('Please select variants.');
      return;
    }

    btn.disabled = true;
    btn.textContent = 'Adding...'; // span is destroyed here — that's fine now

    try {

      const addRes = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items })
      });

      if (!addRes.ok) {
        const err = await addRes.json();
        throw new Error(err.description || 'Failed to add');
      }

      await fetch('/cart.js', { cache: 'no-store' });

      await updateCartBubble();
      await refreshCartDrawer();
      openCartDrawer();

    } catch (err) {

      console.error(err);
      alert(err.message || 'Something went wrong');

    } finally {

      btn.disabled = false;

      // ✅ Rebuild span with saved dis-per — does NOT use textContent
      btn.innerHTML =
        `One Time Purchase - <span class="onetime-priced" dis-per="${disPer}"></span>`;

      // ✅ Repopulate price into the fresh span
      setTimeout(() => updateOneTimeVariantStorage(), 300);
    }
  });
});


// ==========================================
// UPDATE CART BUBBLE
// ==========================================
async function updateCartBubble() {

  try {

    const res = await fetch('/?section_id=header', { cache: 'no-store' });
    const text = await res.text();
    const doc = new DOMParser().parseFromString(text, 'text/html');

    const newBubble = doc.querySelector('#cart-icon-bubble');
    const oldBubble = document.querySelector('#cart-icon-bubble');

    if (newBubble && oldBubble) oldBubble.replaceWith(newBubble);

  } catch (err) {
    console.error('Bubble update failed:', err);
  }
}


// ==========================================
// REFRESH CART DRAWER
// ==========================================
async function refreshCartDrawer() {

  const res = await fetch('/cart?section_id=cart-drawer', {
    cache: 'no-store',
    headers: { 'x-requested-with': 'XMLHttpRequest' }
  });

  const text = await res.text();
  const doc = new DOMParser().parseFromString(text, 'text/html');

  const newDrawer = doc.querySelector('cart-drawer');
  const oldDrawer = document.querySelector('cart-drawer');

  if (newDrawer && oldDrawer) {
    oldDrawer.replaceWith(newDrawer);
    newDrawer.dispatchEvent(new Event('cart:refresh', { bubbles: true }));
    document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
  }
}


// ==========================================
// OPEN CART DRAWER
// ==========================================
function openCartDrawer() {

  const drawer = document.querySelector('cart-drawer');

  if (!drawer) {
    window.location.href = '/cart';
    return;
  }

  drawer.classList.add('active');

  const overlay = document.querySelector(
    '.cart-drawer-overlay, .drawer-overlay, [class*="cart-overlay"]'
  );

  if (overlay) overlay.classList.add('active');

  document.body.classList.add('overflow-hidden');
}